import React from "react"

export const HappyEmojiSvg = ({ width, height }) => (
  <svg width={width ?? "28"} height={height ?? "28"} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2043_3530)">
      <path d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z" fill="#FFCC4D" />
      <path d="M14.0009 16.3336C11.183 16.3336 9.3132 16.0053 7.00087 15.5558C6.47276 15.4539 5.44531 15.5558 5.44531 17.1113C5.44531 20.2225 9.0192 24.1113 14.0009 24.1113C18.9818 24.1113 22.5564 20.2225 22.5564 17.1113C22.5564 15.5558 21.529 15.4531 21.0009 15.5558C18.6885 16.0053 16.8188 16.3336 14.0009 16.3336Z" fill="#664500" />
      <path d="M7 17.1113C7 17.1113 9.33333 17.8891 14 17.8891C18.6667 17.8891 21 17.1113 21 17.1113C21 17.1113 19.4444 20.2224 14 20.2224C8.55556 20.2224 7 17.1113 7 17.1113Z" fill="white" />
      <path d="M9.33312 13.2223C10.407 13.2223 11.2776 12.0035 11.2776 10.5001C11.2776 8.99661 10.407 7.77783 9.33312 7.77783C8.25923 7.77783 7.38867 8.99661 7.38867 10.5001C7.38867 12.0035 8.25923 13.2223 9.33312 13.2223Z" fill="#664500" />
      <path d="M18.6671 13.2223C19.741 13.2223 20.6115 12.0035 20.6115 10.5001C20.6115 8.99661 19.741 7.77783 18.6671 7.77783C17.5932 7.77783 16.7227 8.99661 16.7227 10.5001C16.7227 12.0035 17.5932 13.2223 18.6671 13.2223Z" fill="#664500" />
    </g>
    <defs>
      <clipPath id="clip0_2043_3530">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>

)